import { InputNumber } from "primereact/inputnumber";
import { Controller } from "react-hook-form";

// Types
import { ICommonProps } from "../types";

export function UnformalMonthlyIncome({ control, formState, setValue }: ICommonProps<any, any, any, any>) {
    return (<span className="md:flex-1 max-sm:w-full md:min-w-[48%] md:max-w-[50%] flex flex-col gap-2 border-b-[1px] border-gray-300">
        <label htmlFor="">Renda mensal informal?</label>
        <span data-haserrors={formState?.errors?.unformal_monthly_income?.message && true}
            className="hidden data-[haserrors=true]:flex text-red-400 text-sm">{formState?.errors?.unformal_monthly_income?.message}</span>
        <Controller
            control={control}
            name="unformal_monthly_income"
            render={({
                field,
            }) => (
                // @ts-ignore
                <InputNumber
                    name={field.name}
                    mode="currency" aria-autocomplete="none"
                    currency="BRL"
                    placeholder="R$ 0,00"
                    className="w-full !bg-transparent !border-none  !rounded-none"
                    inputClassName="w-full !bg-transparent !border-none  !rounded-none"
                    onChange={d => setValue('unformal_monthly_income', (d?.value || 0.0).toFixed(2))}
                />
            )}
        />
    </span>
    )
}